import {
   SurveyNotUpdatableFault,
   SurveyTemplateVersionAlreadyPublishedFault,
   SurveyTemplateVersionCreateCommand,
   SurveyTemplateVersionPublishCommand,
   SurveyTemplateVersionUpdateCommand,
} from '@dreryk/egabinet-survey-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';

import { SurveyPreInterviewTemplateFormBean } from './SurveyPreInterviewTemplateForm.types';

const PREINTERVIEW_TEMPLATE_CODE = 'PREINTERVIEW';

export const useSurveyTemplateVersionCreateCommand = (): UseCqrsCommandResult<number> => {
   return useCqrsCommand(() => {
      const command = new SurveyTemplateVersionCreateCommand();
      command.templateCode = PREINTERVIEW_TEMPLATE_CODE;
      return command;
   });
};

type UseSurveyTemplateVersionUpdateCommandParameters = {
   formData: SurveyPreInterviewTemplateFormBean;
   preInterviewTemplateId: number;
};

type UseSurveyTemplateVersionUpdateCommandOptions = {
   onSuccess?: VoidFunction;
};

export const useSurveyTemplateVersionUpdateCommand = (
   options: UseSurveyTemplateVersionUpdateCommandOptions
): UseCqrsCommandResult<void, UseSurveyTemplateVersionUpdateCommandParameters, SurveyNotUpdatableFault> => {
   return useCqrsCommand(
      ({ formData, preInterviewTemplateId }) => {
         const command = new SurveyTemplateVersionUpdateCommand();
         command.id = preInterviewTemplateId;
         command.questions = formData.questions.map((question) => ({ content: question.content }));
         return command;
      },
      {
         onSuccess: () => {
            options.onSuccess?.();
         },
         onFault: {
            'egabinet-survey-frontend-api:SurveyNotUpdatableFault': () => {
               dispatchSnackbarNegativeEvent(
                  generalSettingsTranslationKeys.survey.preInterview.form.errors.surveyNotUpdatableFault
               );
            },
         },
      }
   );
};

type useSurveyTemplateVersionPublishCommandOptions = {
   onSuccess: VoidFunction;
};

export const useSurveyTemplateVersionPublishCommand = (
   options: useSurveyTemplateVersionPublishCommandOptions
): UseCqrsCommandResult<void, number, SurveyTemplateVersionAlreadyPublishedFault> => {
   return useCqrsCommand(
      (preInterviewTemplateId) => {
         const command = new SurveyTemplateVersionPublishCommand();
         command.id = preInterviewTemplateId;
         return command;
      },
      {
         onSuccess: options.onSuccess,
         onFault: {
            'egabinet-survey-frontend-api:SurveyTemplateVersionAlreadyPublishedFault': () => {
               dispatchSnackbarNegativeEvent(
                  generalSettingsTranslationKeys.survey.preInterview.form.errors
                     .surveyTemplateVersionAlreadyPublishedFault
               );
            },
         },
      }
   );
};
